/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rv_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the difference between reversing words and reversing lines?`)
};

const es_rv_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es la diferencia entre invertir palabras e invertir líneas?`)
};

const de_rv_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist der Unterschied zwischen dem Umkehren von Wörtern und dem Umkehren von Zeilen?`)
};

const nl_rv_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is het verschil tussen het omkeren van woorden en het omkeren van lijnen?`)
};

const fr_rv_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle est la différence entre inverser des mots et inverser des lignes ?`)
};

const it_rv_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è la differenza tra l'inversione di parole e l'inversione di righe?`)
};

const pt_br2_rv_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a diferença entre inverter palavras e inverter linhas?`)
};

const pt_rv_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a diferença entre inverter palavras e inverter linhas?`)
};

const ja_rv_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単語の反転と行の反転の違いは何ですか?`)
};

const zh_rv_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`反转单词和反转行有什么区别？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rv_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rv_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rv_faq4_q", locale)
	if (locale === "en") return en_rv_faq4_q(inputs)
	if (locale === "es") return es_rv_faq4_q(inputs)
	if (locale === "de") return de_rv_faq4_q(inputs)
	if (locale === "nl") return nl_rv_faq4_q(inputs)
	if (locale === "fr") return fr_rv_faq4_q(inputs)
	if (locale === "it") return it_rv_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_rv_faq4_q(inputs)
	if (locale === "pt") return pt_rv_faq4_q(inputs)
	if (locale === "ja") return ja_rv_faq4_q(inputs)
	return zh_rv_faq4_q(inputs)
};